import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Icon } from "semantic-ui-react";

import { WarningNotification } from "modules/KeyLockersDashboard/components/KeyLockerWarning/components";
import { useCcSettingsQuery } from "modules/KeyLockersDashboard/components/KeyLockerWarning/hooks";

export const useKeyLockerWarning = () => {
  const { t } = useTranslation();

  const { data: ccSettings, isSuccess: ccSettingsSuccess } = useCcSettingsQuery();

  useEffect(() => {
    if (ccSettings && !ccSettings.online_check_in_send_pin)
      toast(WarningNotification({ t }), {
        icon: <Icon className="triangle exclamation" color="red" size="large" />,
        hideProgressBar: true,
        style: { width: "400px", right: "80px" },
        closeButton: false
      });
  }, [ccSettingsSuccess]);
};
